import React from 'react';
import ToolLayout from '../../components/ToolLayout';
import ColorPickerFromImage from '../../components/ColorPickerFromImage';

const ColorPickerPage: React.FC = () => (
  <ToolLayout
    title="Color Picker from Image - Extract Colors | AllTools"
    description="Pick colors from any image. Get HEX, RGB, and HSL values. Build color palettes. Free eyedropper tool."
    canonicalPath="/color-picker-from-image"
  >
    <ColorPickerFromImage />
  </ToolLayout>
);

export default ColorPickerPage;
